import React, {Component} from "react";
import Header, {HeaderMargin} from "./Header";
import Footer from "./Footer";
import CookieConsent from "./CookieConsentModilect";
import styled, {keyframes} from "styled-components";
import {Contain} from "../Tools/Variables";

const Wrapper = styled.div `
  margin: 0;
`;

const CookieAnim = keyframes ` 
from {
  visibility:visible;
  opacity: 0.1;}
  to {opacity: 1;
    visibility:visible;
}
`;

const AnimateCookie = styled.div `
  position: absolute;
  z-index: 9999;
  opacity: 0;
  visibility: hidden;
  animation-fill-mode: forwards;
  animation-name: ${CookieAnim};
  animation-delay: 4s;
  animation-duration: 0.7s;
`;
class PageContainer extends Component {

  render() {
    return (
      <Wrapper>
        <Header
          headerBG={this.props.headerBG}
          setShowContactModal={this.props.setShowContactModal}/>{" "} {this.props.contain
          ? (
            <Contain>{this.props.children}</Contain>
          )
          : (this.props.children)}
        <Footer/>
        <AnimateCookie>
          <CookieConsent/>
        </AnimateCookie>
      </Wrapper>
    );
  }
}

export default PageContainer;



// WEBPACK FOOTER //
// ./src/Global/PageContainer.js